import './cep'
import './data'
import './telefone'
import './horario'
import './moeda'
import './cpf-cnpj'
import './numero'
import './ean'
import './teclas'